import { defineComponent as _defineComponent } from 'vue'
type Props = {
  color?: string;
  depressed?: boolean;
};
type Emits = {
  (e: "click"): void;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'SubmitButton',
  props: {
    color: { default: "success" },
    depressed: { type: Boolean, default: true }
  },
  emits: ["click"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "click"): void;
}), expose: any, slots: any, attrs: any }) {




const onClick = () => {
  emits("click");
};

return { __sfc: true,emits, onClick }
}

})